module.exports = __webpack_public_path__ + "static/media/image21.a4b62537.jpg";